"use strict";

exports.__esModule = true;
exports["default"] = removeCorruptedEntities;

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isLegacyImage = function isLegacyImage(entity) {
  return entity.type === 'IMAGE';
};

var isImage = function isImage(entity) {
  return entity.type === 'wix-draft-plugin-image';
};

var isGallery = function isGallery(entity) {
  return entity.type === 'wix-draft-plugin-gallery';
};

var isSmallSizeGridGalleryWithoutPerRowValue = function isSmallSizeGridGalleryWithoutPerRowValue(entity) {
  return isGallery(entity) && !(0, _lodash.has)(entity, 'data.styles.numberOfImagesPerRow') && (0, _lodash.get)(entity, 'data.styles.galleryLayout') === 2 && (0, _lodash.get)(entity, 'data.config.size') === 'small';
};

var isVideoEmbed = function isVideoEmbed(entity) {
  return entity.type === 'VIDEO-EMBED';
};

var isLink = function isLink(entity) {
  return entity.type === 'LINK';
};

var isEntityWithoutData = function isEntityWithoutData(entity) {
  return (isLegacyImage(entity) || isVideoEmbed(entity)) && (0, _lodash.isEmpty)(entity.data);
};

var isImageWithoutSrc = function isImageWithoutSrc(entity) {
  return isLegacyImage(entity) && !(0, _lodash.get)(entity, 'data.src');
};

var isImageWithoutConfig = function isImageWithoutConfig(entity) {
  return isImage(entity) && !(0, _lodash.get)(entity, 'data.config');
};

var isVideoWithoutUrl = function isVideoWithoutUrl(entity) {
  return isVideoEmbed(entity) && !(0, _lodash.get)(entity, 'data.url');
};

var isLinkWithoutUrl = function isLinkWithoutUrl(entity) {
  return isLink(entity) && !(0, _lodash.get)(entity, 'data.url');
};

var isCorrupted = function isCorrupted(entity) {
  return isEntityWithoutData(entity) || isImageWithoutSrc(entity) || isVideoWithoutUrl(entity);
};

var hasOneOfEntities = function hasOneOfEntities(block, entityKeys) {
  return entityKeys.indexOf((0, _lodash.get)(block, 'entityRanges[0].key')) > -1;
};

function isVersionBefore(before, version) {
  if ((0, _lodash.isEmpty)(version)) {
    return true;
  }

  if (before === version) {
    return false;
  }

  var _ref = [before.split('.'), version.split('.')];
  before = _ref[0];
  version = _ref[1];

  for (var i = 0; i < 3; i++) {
    var diff = Number(before[i] || 0) - Number(version[i] || 0);

    if (diff > 0) {
      return true;
    }

    if (diff < 0) {
      return false;
    }
  }

  return false;
}

var getCorrupted = function getCorrupted(entityMap) {
  return Object.keys(entityMap).reduce(function (acc, key) {
    var entity = entityMap[key];

    if (isCorrupted(entity)) {
      acc.corruptedEntityKeys.push(Number(key));
    } else if (isLinkWithoutUrl(entity)) {
      acc.invalidLinkEntityKeys.push(Number(key));
    }

    return acc;
  }, {
    corruptedEntityKeys: [],
    invalidLinkEntityKeys: []
  });
};

var removeCorrupted = function removeCorrupted(corruptedEntityKeys, content) {
  var entityMap = content.entityMap;

  var isValidEntityRange = function isValidEntityRange(entityRange) {
    var entity = entityMap[entityRange.key];
    return entity && !isLinkWithoutUrl(entity);
  };

  return content.blocks.reduce(function (acc, block) {
    if (hasOneOfEntities(block, corruptedEntityKeys)) {
      return acc;
    }

    if (Array.isArray(block.entityRanges) && block.entityRanges.length) {
      block.entityRanges = block.entityRanges.filter(isValidEntityRange);
    }

    acc.push(block);
    return acc;
  }, []);
};

var tempFix = function tempFix(entityMap, version) {
  Object.keys(entityMap).forEach(function (key) {
    var entity = entityMap[key];

    if (isImageWithoutConfig(entity)) {
      entity.type = 'IMAGE';
    } else if (isSmallSizeGridGalleryWithoutPerRowValue(entity) && isVersionBefore('6.9.2', version)) {
      (0, _lodash.set)(entity, 'data.styles.numberOfImagesPerRow', 2);
    }
  });
  return entityMap;
};
/**
 * Removes invalid entities which were corrupted by bugs in wix-rich-content-editor
 */


function removeCorruptedEntities(content) {
  if (!content) {
    return content;
  }

  var _getCorrupted = getCorrupted(content.entityMap),
      corruptedEntityKeys = _getCorrupted.corruptedEntityKeys,
      invalidLinkEntityKeys = _getCorrupted.invalidLinkEntityKeys;

  return _objectSpread({}, content, {
    blocks: removeCorrupted(corruptedEntityKeys, content),
    entityMap: tempFix((0, _lodash.omit)(content.entityMap, [].concat(corruptedEntityKeys, invalidLinkEntityKeys)), content.VERSION)
  });
}